import Marquee from "react-fast-marquee";

const ITEMS = ["CUSTOM PRINT", "HIGH-DENSITY EMBROIDERY", "480GSM HEAVYWEIGHT", "NO MINIMUMS", "48H DISPATCH", "YOUR ART. OUR MACHINES."];

export default function EditorialMarquee() {
  return (
    <div className="border-y border-white/10 bg-surface py-5 overflow-hidden" data-testid="editorial-marquee">
      <Marquee speed={35} gradient={false} pauseOnHover>
        {ITEMS.map((t, i) => (
          <span key={i} className="flex items-center">
            <span className={`font-display text-2xl md:text-3xl uppercase tracking-wide mx-6 ${i % 2 ? "text-outline-orange" : "text-outline"}`}>{t}</span>
            <span className="w-2 h-2 bg-kinetic rotate-45 inline-block mx-2" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
